import { useId, type ReactNode } from 'react';
import { cn } from '@shared/lib/cn';
import { Label } from './label';

interface FormFieldProps {
  label?: ReactNode;
  hint?: ReactNode;
  error?: string | undefined;
  required?: boolean;
  className?: string;
  children: (props: {
    id: string;
    'aria-describedby': string | undefined;
    invalid: boolean;
  }) => ReactNode;
}

export function FormField({ label, hint, error, required, className, children }: FormFieldProps) {
  const id = useId();
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = error ? errorId : hint ? hintId : undefined;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label ? (
        <Label htmlFor={id}>
          {label}
          {required ? <span className="ml-0.5" style={{ color: 'var(--ant-color-error)' }}>*</span> : null}
        </Label>
      ) : null}
      {children({ id, 'aria-describedby': describedBy, invalid: Boolean(error) })}
      {error ? (
        <p id={errorId} role="alert" className="m-0 text-xs" style={{ color: 'var(--ant-color-error)' }}>
          {error}
        </p>
      ) : hint ? (
        <p id={hintId} className="m-0 text-xs opacity-70">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
